import React from 'react'
import GenericPullConfigListing from '../GenericPullConfigListing'
import AppknoxCredentialsForm from './AppknoxCredentialsForm'
import AppknoxMappingForm from './AppknoxMappingForm'

export default function AppknoxConfigListing(props) {
    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={AppknoxMappingForm}
            CredentialsForm={AppknoxCredentialsForm}
            componentName="Package"
            componentKey="package"
            showOrganisationColumn={true}
        />
    )
}